import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'

export const Wrap = styled.div`
  margin: ${LAYOUT.VERTICALSPACEMOBILE} 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  max-width: 1280px;
  ${MEDIA.medium`
  margin: ${LAYOUT.VERTICALSPACEMOBILE} auto ${LAYOUT.VERTICALSPACE} ;
  `}
`

export const ButtonFooter = styled.div`
  width: 100%;
  border-top: 4px solid #dcddde;
  text-align: center;
  margin-top: 40px;
  padding-top: 40px;
`
